export class JuridicaEconomica {

    constructor({ tipoFrmEmpresa = null } = {}) {
        this.tipoFrmEmpresa = tipoFrmEmpresa;
        this.model = {
            ingreso_mensual: {
                value: 0,
                header: 'Ingreso mensual USD:',
                required: 'Ingreso mensual es requerido'
            },
            egreso_mensual: {
                value: 0,
                header: 'Egreso mensual USD:',
                required: 'Egreso mensual es requerido'
            },
            total_activo_corriente: {
                value: 0,
                header: 'Total activo corriente USD:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Activo Corriente',
                    FRM_DIFARE: 'Activo Corriente',
                },
                required: 'Total activo corriente es requerido',
            },
            total_activo_no_corriente: {
                value: 0,
                header: 'Total activo no corriente USD:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Activo No Corriente',
                    FRM_DIFARE: 'Activo No Corriente',
                },
                required: 'Total activo no corriente es requerido'
            },
            total_activos: {
                value: 0,
                header: 'Total activos USD:',
                required: 'Total activos es requerido'
            },
            total_pasivo_corriente: {
                value: 0,
                header: 'Total pasivo corriente USD:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Pasivo Corriente',
                    FRM_DIFARE: 'Pasivo Corriente',
                },
                required: 'Total pasivo corriente es requerido'
            },
            total_pasivo_no_corriente: {
                value: 0,
                header: 'Total pasivo no corriente USD:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Pasivo No Corriente',
                    FRM_DIFARE: 'Pasivo No Corriente',
                },
                required: 'Total pasivo no corriente es requerido'
            },
            total_pasivos: {
                value: 0,
                header: 'Total pasivos USD:',
                required: 'Total pasivos es requerido'
            },
            patrimonio: {
                value: 0,
                header: 'PATRIMONIO (ACTIVOS - PASIVOS) USD:',
                headerPorTipo: {
                    FRM_TOYOTA: 'Patrimonio USD:',
                    FRM_DIFARE: 'Patrimonio USD:',
                },
                required: 'Patrimonio es requerido'
            },
            ingreso_anio: {
                value: 0,
                header: 'Ingresos año anterior USD:',
                required: 'Ingreso es requerido'
            },
            egreso_anio: {
                value: 0,
                header: 'Egresos año anterior USD:',
                required: 'Egreso es requerido'
            }
        }
        Object.keys(this.model).forEach((key) => {
            const campo = this.model[key];
            if (campo.headerPorTipo && tipoFrmEmpresa && campo.headerPorTipo[tipoFrmEmpresa] !== undefined) {
                campo.header = campo.headerPorTipo[tipoFrmEmpresa];
            }
            if (campo.tablePorTipo && tipoFrmEmpresa && campo.tablePorTipo[tipoFrmEmpresa] !== undefined) {
                campo.table = campo.tablePorTipo[tipoFrmEmpresa];
            }
        });
    }
}
